import { render } from "./VehicleEntryCreatePage.vue?vue&type=template&id=b486fc7e"
import script from "./VehicleEntryCreatePage.vue?vue&type=script&lang=js"
export * from "./VehicleEntryCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__